const searchableText = (value) => String(value ?? "").toLocaleLowerCase("pt-BR");

export const filterCurveResources = (items = [], rawQuery = "") => {
  const query = searchableText(rawQuery).trim();
  if (!query) return items;
  return items.filter((item) => (
    searchableText(item?.name).includes(query)
    || searchableText(item?.id).includes(query)
  ));
};

export const presentationViewKey = (pathname = "", project = {}) => (
  `${pathname}::${String(project?._id ?? project?.building_id ?? "")}`
);
